import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import SyncIcon from "@mui/icons-material/Sync";
import { toast } from "react-hot-toast";

import {
	Typography,
	Button,
	Autocomplete, TextField, Chip,
	Switch
} from "@mui/material";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import {
  triggerPHDSyncWithSalesforce,
} from "../../Containers/api";


const useReduxSelectors = () => {
	const selectedProjectId = useSelector(
		(state) => state.project.selectedProjectId
	);
	// Remove settingsData, only keep users
	const users = useSelector(
		(state) => state.project.users
	);
	return { selectedProjectId, users };
};

const CostStatusSettingsPanel = ({
	setMonthlyCostStatusActive,
	setRecipients,
	monthlyCostStatusActive,
	recipients,
	bvtFields,
	setBvtFields,
}) => {
	const { selectedProjectId, users } = useReduxSelectors(); // Only use users

	function updateMonthlyCostStatusSettings(type, value) {
		if (type === 'monthly_cost_status_active') {
			// Send to API.
			setMonthlyCostStatusActive(value);
		} else if (type === 'recipients') {
			setRecipients(value);
		}
	}

	const handleTriggerSalesforceSync = async (e) => {
		e.preventDefault();
		try {
		await triggerPHDSyncWithSalesforce(selectedProjectId);
		toast.success("Salesforce sync triggered successfully!", {
			className: "titillium-web",
		});
		} catch (error) {
		console.error("Error triggering Salesforce sync:", error);
		toast.error(`Error triggering Salesforce sync: ${error.message}`, {
			className: "titillium-web",
		});
		}
	};


	return (
	<>
		<div style={{ padding: "20px" }}>
			<div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
				<Typography variant="h6" className="titillium-web" gutterBottom>
					Monthly Cost Status Settings
				</Typography>
			</div>
			<div style={{ marginTop: "20px" }}>
				<div
					style={{
						display: "flex",
						flexDirection: "row",
						gap: "1px",
						alignItems: "center",
					}}
				>
					<Typography>This project is expecting Monthly Cost Status Snapshots and submissions</Typography>
					<Switch
						checked={monthlyCostStatusActive}
						onChange={(e) => updateMonthlyCostStatusSettings('monthly_cost_status_active', e.target.checked)}
						color="primary"
					/>
				</div>
				<br />
				<div>
					<div
						style={{
						display: "flex",
						flexDirection: "row",
						gap: "1px",
						alignItems: "center",
						}}
					>
						<Typography>Salesforce Sync</Typography>
						<Switch
						checked={bvtFields.phd_sync}
						onChange={(e) =>
							setBvtFields({ ...bvtFields, phd_sync: e.target.checked })
						}
						color="primary"
						/>
						<Button
							className="outlined-primary-button"
							endIcon={<SyncIcon />}
							onClick={handleTriggerSalesforceSync}
							style={{maxHeight: '30px'}}
						>
							Trigger Sync to Salesforce Now
						</Button>
					</div>
					<Typography style={{color: 'darkgray'}}>Turn this switch on to sync "Revised Contract Amount" and "Cost Status Profit" from Cost Status to Salesforce. Keep it on unless your project has special conditions (e.g., not using the Procore Budget). <br />Questions? Contact: <a style={{textDecoration: 'none', color: 'inherit'}} href="mailto:innovation@arcomurray.com?subject=PHD Feedback">innovation@arcomurray.com</a></Typography>
					<br />
				</div>
				<br />
				<div>
					<Typography>Select the recipients of the Cost Status Email:</Typography>
					<div style={{ padding: '10px', height: '100px' }}>
						<Autocomplete
							multiple
							options={users}
							getOptionLabel={(option) => `${option.name} <${option.email}>`}
							filterSelectedOptions
							value={recipients}
							onChange={(event, newValue) => {
								updateMonthlyCostStatusSettings('recipients', newValue);
							}}
							renderTags={(value, getTagProps) =>
								value.map((option, index) => (
								<Chip
									key={option.email}
									label={`${option.name} <${option.email}>`}
									style ={{ margin: '2px', backgroundColor: '#093D61', color: 'white'}}
									deleteIcon={
										<HighlightOffIcon style={{ color: 'white' }} />
									}
									{...getTagProps({ index })}
								/>
								))
							}
							renderInput={(params) => (
								<TextField
								{...params}
								variant="outlined"
								label="Recipients"
								placeholder="Type name or email"
								/>
							)}
							isOptionEqualToValue={(option, value) =>
								option.email === value.email
							}
						/>
					</div>
				</div>
			</div>
		</div>
	</>
	);
};

export default CostStatusSettingsPanel;